import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Grid2X2, ShoppingCart, MessageCircle, MoreHorizontal } from 'lucide-react';
import { useCart } from '../../context/CartContext';

/**
 * PWA Bottom Navigation - Vollständig funktionale Tab-Leiste
 */
const PWABottomNav = () => {
  const location = useLocation();
  const { cartItems } = useCart();
  
  const cartCount = cartItems?.reduce((sum, item) => sum + (item.quantity || 1), 0) || 0;
  
  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/produkte', icon: Grid2X2, label: 'Produkte' },
    { path: '/warenkorb', icon: ShoppingCart, label: 'Warenkorb', badge: cartCount },
    { path: '/kontakt', icon: MessageCircle, label: 'Kontakt' },
    { path: '/mehr', icon: MoreHorizontal, label: 'Mehr' },
  ];

  const isActive = (item) => {
    if (item.path === '/') {
      return location.pathname === '/';
    }
    if (item.path === '/produkte') {
      // "Produkte" is active for /produkte and all category pages
      return location.pathname === '/produkte' || 
        ['/bagger', '/radlader', '/gabelstapler', '/ruettelplatten', '/stampfer', '/zubehoer'].some(p => 
          location.pathname.startsWith(p)
        );
    }
    return location.pathname.startsWith(item.path);
  };

  return (
    <nav className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 z-50">
      <div className="flex items-center justify-around h-16 max-w-lg mx-auto">
        {navItems.map((item) => {
          const Icon = item.icon;
          const active = isActive(item);
          
          return (
            <Link
              key={item.path}
              to={item.path}
              className="flex flex-col items-center justify-center flex-1 h-full relative"
            >
              <div className="relative">
                <Icon 
                  size={24} 
                  strokeWidth={active ? 2.5 : 1.5}
                  className={active ? 'text-red-600' : 'text-gray-400'}
                />
                {item.badge > 0 && (
                  <span className="absolute -top-1.5 -right-1.5 min-w-[18px] h-[18px] bg-red-600 text-white text-[10px] font-bold rounded-full flex items-center justify-center px-1">
                    {item.badge > 99 ? '99+' : item.badge}
                  </span>
                )}
              </div>
              <span className={`text-[10px] mt-1 ${
                active ? 'text-red-600 font-semibold' : 'text-gray-500'
              }`}>
                {item.label}
              </span>
            </Link>
          );
        })}
      </div>
      {/* iOS Safe Area */}
      <div className="bg-white" style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }} />
    </nav>
  );
};

export default PWABottomNav;
